import Vue from 'vue'
// @ts-ignore
import { BlankView, SplitView } from './layout/index.ts'
import Ellipsis from '../src/components/Ellipsis/index'
Vue.component('blank-view', BlankView)
Vue.component('split-view', SplitView)
Vue.component('ellipsis', Ellipsis)

import WmDrawer from '@/components/WmDrawer/index.vue'
Vue.component('WmDrawer', WmDrawer)

import WmEmpty from '@/components/WmEmpty/index.vue'
Vue.component('WmEmpty', WmEmpty)

import UploadImg from '@/components/UploadImg/index.vue'
Vue.component('UploadImg', UploadImg)

import ImportButton from '@/components/ImportButton/index.vue'
import ExportButton from '@/components/ExportButton/index.vue'
Vue.component('import-button', ImportButton)
Vue.component('export-button', ExportButton)

import CodeModel from '@/components/CodeModel/index.vue'
Vue.component('code-model', CodeModel)

import TenantSelect from '@/components/TenantSelect/index.vue'
Vue.component('tenant-select', TenantSelect)

import InputIp from '@/components/InputIp/index.vue'
Vue.component('input-ip', InputIp)
import InputIpDemo from '@/components/InputIp/InputIpDemo.vue'
Vue.component('input-ip-demo', InputIpDemo)

import VirtualScroller from '@/components/VirtualScroller/VirtualScroller.vue'
Vue.component('ml-virtual-scroller', VirtualScroller)
import VirtualScrollerTable from '@/components/VirtualScroller/VirtualScrollerTable.vue'
Vue.component('ml-vs-table', VirtualScrollerTable)
import VirtualScrollerDemo from '@/components/VirtualScroller/VirtualScrollerDemo.vue'
Vue.component('ml-virtual-scroller-demo', VirtualScrollerDemo)

import LabelProcessing from '@/components/LabelProcessing/LabelProcessing.vue'
Vue.component('label-processing', LabelProcessing)